import { render, staticRenderFns } from "./DashboardDateFilters.vue?vue&type=template&id=2ac65a63&scoped=true"
import script from "./DashboardDateFilters.vue?vue&type=script&lang=js"
export * from "./DashboardDateFilters.vue?vue&type=script&lang=js"
import style0 from "./DashboardDateFilters.vue?vue&type=style&index=0&id=2ac65a63&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac65a63",
  null
  
)

export default component.exports